import { useIntl } from 'react-intl'
import { faPlus } from '@fortawesome/pro-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'

import type { AddTagButtonProps } from './AddTagButton.types'

export const AddTagButton = (props: AddTagButtonProps) => {
  const { onClick, visible } = props
  const intl = useIntl()

  if (!visible) {
    return null
  }

  return (
    <button
      aria-label={intl.formatMessage({ id: 'Tags_add_tag' })}
      className="AddTagButton"
      onClick={onClick}
      type="button"
    >
      <FontAwesomeIcon icon={faPlus} size="xs" />
    </button>
  )
}
